import { ICardElementWithChildren } from "backend/model/model";

export const defaultSortFunction = (
  a: ICardElementWithChildren,
  b: ICardElementWithChildren
) => {
  return a.index && b.index ? Number(a.index) - Number(b.index) : 0;
};

export const resultSort = (list: ICardElementWithChildren[]) => {
  const res = list.sort(defaultSortFunction);
  res.forEach((item) => {
    if (item.children) {
      item.children = resultSort(item.children);
    }
  });
  return res;
};
